import { render } from "./MasterRouteTable.vue?vue&type=template&id=5401ebbc&scoped=true"
import script from "./MasterRouteTable.vue?vue&type=script&lang=js"
export * from "./MasterRouteTable.vue?vue&type=script&lang=js"

import "./MasterRouteTable.vue?vue&type=style&index=0&id=5401ebbc&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5401ebbc"]])

export default __exports__